import * as core from '../../../../../../../core'

import { query } from './edit-term.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.conditions.widgets.edit-term',
    description: 'Edit Term',
    name: 'Edit Term',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
